import React from 'react'
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

export default function HomeSnapshot({data, description}) {
  return (
    <Card variant="outlined" sx={{
        background:
        "linear-gradient(45deg, #fc00ff 10%, #4A00E0 60%)",
    }}>
      <React.Fragment>
        <CardContent>
          <Typography sx={{ fontSize: 25 }}  gutterBottom>
            {data}
          </Typography>
          <Typography variant="body2">{description}</Typography>
        </CardContent>
      </React.Fragment>
    </Card>
  )
}
